/**
 * Map UI treats soil moisture as 0–100%. API fields (`rsm_0_10cm` fallback, etc.) can be other scales.
 */
export function sanitizeSoilMoisturePercent(value: unknown): number | null {
  if (typeof value !== 'number' || Number.isNaN(value)) return null;
  if (value < 0 || value > 100) return null;
  return value;
}
